module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00181.590f1b68.jpg";